import { render, staticRenderFns } from "./KVKQuestion.vue?vue&type=template&id=d1ff81d8&scoped=true"
import script from "./KVKQuestion.vue?vue&type=script&lang=js"
export * from "./KVKQuestion.vue?vue&type=script&lang=js"
import style0 from "./KVKQuestion.vue?vue&type=style&index=0&id=d1ff81d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff81d8",
  null
  
)

export default component.exports